import type { CSSProperties, ReactNode } from 'react';

// Array of components with key
export type CwK<T> = Array<T & { key: string | number }>;
export type Maybe<T> = T | undefined | null;
export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export type Dictionary<T extends any, K extends string = string> = Record<K, T>;

export type ValueOf<T> = T[keyof T];

export type NonEmptyArray<T> = [T, ...T[]];

export type MustInclude<T, U extends T[]> = [T] extends [ValueOf<U>] ? U : never;

export type Cmp<T extends {}> = T & { children: ReactNode };

export type Classnames<T extends string> = {
  [P in T]?: string;
};

export type Styles<T extends string> = {
  [P in T]?: CSSProperties;
};

export type RenderFn = ReactNode | (() => ReactNode);

export type BasicValue = string | number | undefined | null;

/**
 * this is copied as-is from backend graphql, because PriceNode as a type is shared by non-graphql apps
 */
export enum Currency {
  Chf = 'CHF',
  Eur = 'EUR',
}
export interface PriceNode {
  currency?: Currency | null;
  decimals?: number;
  discount?: number | null;
  hideZero?: boolean;
  hint?: string | string[];
  isDelta?: boolean;
  original?: number | null;
  showBadge?: boolean;
  total: number;
  unit?: string;
  withDefaults?: number | null;
  leftover?: number;
  hideDiscount?: boolean;
  isSnowCoin?: boolean;
}

export type GeoPointDB = {
  longitude: Maybe<number>;
  latitude: Maybe<number>;
};

export type GeoPoint = {
  longitude: number;
  latitude: number;
};

export type UpdaterFn<S> = (prev: S) => S;
